var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('sigfoco-date-picker', {
    ref: "dataInicioPicker",
    attrs: {
      "label": "Início do Período",
      "cols": 2,
      "removeIcon": "",
      "dataEdicao": _vm.form.filters.dataInicio
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('v-text', {
    staticClass: "d-flex align-center justify-center",
    staticStyle: {
      "margin-top": "-20px"
    }
  }, [_vm._v("até")]), _c('sigfoco-date-picker', {
    ref: "dataFimPicker",
    attrs: {
      "label": "Fim do Período",
      "cols": 2,
      "removeIcon": "",
      "dataEdicao": _vm.form.filters.dataFim
    },
    model: {
      value: _vm.form.filters.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFim", $$v);
      },
      expression: "form.filters.dataFim"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Perfil",
      "items": _vm.form.lists.listPerfis,
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.perfis,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "perfis", $$v);
      },
      expression: "form.filters.perfis"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": 'Buscar',
      "icon": 'mdi-magnify'
    },
    on: {
      "click": function ($event) {
        return _vm.buscarPeriodos();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Incluir',
      "icon": 'mdi-plus'
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterPeriodoFormacao();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.form.lists.listPeriodoFormacao,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "show-expand": "",
      "expanded": _vm.expanded
    },
    on: {
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: `item.dataInicio`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.formatDate(item.dataInicio)) + " ")];
      }
    }, {
      key: `item.dataFim`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.formatDate(item.dataFim)) + " ")];
      }
    }, {
      key: `item.perfis`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.perfis) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Visualizar',
            "icon": 'mdi-eye-outline',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarPeriodoFormacao(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Editar',
            "icon": 'mdi-pencil',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterPeriodoFormacao(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": 'Excluir',
            "icon": 'mdi-delete',
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.excluirPeriodoFormacao(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.ativo ? 'var(--primary-button-color)' : 'silver'}`,
            "small": true
          },
          on: {
            "click": function ($event) {
              return _vm.inativarAtivarPeriodoFormacao(item);
            }
          }
        })];
      }
    }, {
      key: "expanded-item",
      fn: function (_ref6) {
        var headers = _ref6.headers,
          item = _ref6.item;
        return [_c('td', {
          staticClass: "perfis",
          attrs: {
            "colspan": headers.length
          }
        }, [_c('v-chip-group', {
          attrs: {
            "active-class": "primary--text",
            "column": ""
          }
        }, _vm._l(item.perfis, function (perfil, i) {
          return _c('v-chip', {
            key: i,
            staticClass: "chip-permissao"
          }, [_c('v-icon', {
            staticClass: "perfil",
            attrs: {
              "small": ""
            }
          }, [_vm._v("mdi-account-multiple")]), _vm._v(" " + _vm._s(perfil.nome) + " ")], 1);
        }), 1)], 1)];
      }
    }, {
      key: `item.emUso`,
      fn: function (_ref7) {
        var item = _ref7.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Uso',
            "icon": item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
            "color": item.emUso ? 'green' : 'red',
            "small": true,
            "disabled": !item.emUso
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogDetalharUsoPeriodoFormacao(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1), _c('CadastrarEditarPeriodoFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogManterPeriodoFormacao.visible,
      "content": _vm.dialogManterPeriodoFormacao.content,
      "edit": _vm.dialogManterPeriodoFormacao.edit
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterPeriodoFormacao.close();
      },
      "onSave": function ($event) {
        return _vm.buscarPeriodos();
      }
    }
  }), _c('VisualizarPeriodoFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarPeriodoFormacao.visible,
      "content": _vm.dialogVisualizarPeriodoFormacao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarPeriodoFormacao.close();
      }
    }
  }), _c('DetalharUsoPeriodoFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogDetalharUsoPeriodoFormacao.visible,
      "content": _vm.dialogDetalharUsoPeriodoFormacao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogDetalharUsoPeriodoFormacao.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }